import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { map } from "rxjs";
import { IBaseSearchRequest, IFilter } from "src/app/core/models/base";
import { DeviceService } from "src/app/devices/services/device.service";

export function DeviceCategoryValidator(deviceService: DeviceService, currentCategoryId: string | null): AsyncValidatorFn {
    return (control: AbstractControl) => {
        const filters: IFilter[] = [
            {
                field: 'name',
                operator: 'eq',
                value: control.value
            }
        ];

        // Only add the id filter if currentCategoryId is not null
        if (currentCategoryId) {
            filters.push({
                field: 'id',
                operator: 'neq',
                value: currentCategoryId
            });
        }

        const request: IBaseSearchRequest = {
            pageNumber: 0,
            pageSize: 999999,
            advancedFilter: {
                logic: "and",
                filters: filters
            }
        };

        return deviceService.getAllDeviceCategories(request)
            .pipe(
                map(response => {
                    const deviceCategories = response.data;

                    return deviceCategories.length !== 0 ? { deviceCategoryExists: true } : null;
                })
            );
    }
}
